import { api } from '@/v2/plugins/axios';

class ImportsEntity {
	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static importFiles = async (API_PATH, data) => {
		return api.post(API_PATH, data);
	};

	static downloadTemplate = async (API_PATH, params) => {
		return api.get(API_PATH, { params });
	};
}

export default ImportsEntity;
